export const CHECK_VERIFICATION_STATUS = "CHECK_VERIFICATION_STATUS";
export const UPLOAD_IDENTITY = "UPLOAD_IDENTITY";
export const UPLOAD_IDENTITY_PROGRESS = "UPLOAD_IDENTITY_PROGRESS";
export const UPLOAD_UTILITY = "UPLOAD_UTILITY";
export const UPLOAD_UTILITY_PROGRESS = "UPLOAD_UTILITY_PROGRESS";